var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SteemActionType } from '@popup/steem/actions/action-type.enum';
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
export const setActiveRpc = (rpc) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    // // console.log('[ActiveRpcActions] Setting active RPC:', rpc);
    try {
        // Configura SteemTxUtils
        SteemTxUtils.setRpc(rpc);
        // Salva l'RPC in Preferences
        yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.CURRENT_RPC, rpc);
        // // console.log('[ActiveRpcActions] RPC saved to Preferences');
        // Dispatch dell'azione Redux
        dispatch({
            type: SteemActionType.SET_ACTIVE_RPC,
            payload: rpc,
        });
        // // console.log('[ActiveRpcActions] Active RPC set');
    }
    catch (error) {
        console.error('[ActiveRpcActions] Error setting active RPC:', error);
    }
});
